import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-523d02cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ODadosGrupo",
  "data-testid": "ODadosGrupo"
}

import { computed } from "vue"

  import { MInput, MMultiSelect } from "@/components/Gerais"

  import { EntidadeGenerica } from "@/types/gerais"

  import useVuelidate, { ValidationArgs } from "@vuelidate/core"
  import { helpers, required } from "@vuelidate/validators"
  import { useI18n } from "vue-i18n"

  interface Props {
    nomeGrupo: string
    usuariosResponsaveis: string[]
    usuariosResponsaveisOpcoes: EntidadeGenerica[]
    escopoValidacao?: string
    estaCarregandoUsuariosResponsaveis: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ODadosGrupo',
  props: {
    nomeGrupo: null,
    usuariosResponsaveis: null,
    usuariosResponsaveisOpcoes: null,
    escopoValidacao: null,
    estaCarregandoUsuariosResponsaveis: { type: Boolean }
  },
  emits: ["update:nomeGrupo", "update:usuariosResponsaveis"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:nomeGrupo", nomeGrupo: string)
    (event: "update:usuariosResponsaveis", usuariosResponsaveis: string[]): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    nomeGrupo: string
    usuariosResponsaveis: string[]
    usuariosResponsaveisOpcoes: EntidadeGenerica[]
    escopoValidacao?: string
    estaCarregandoUsuariosResponsaveis: boolean
  }

  const { t } = useI18n()

  

  

  const emitirnomeGrupo = computed({
    get() {
      return props.nomeGrupo
    },
    set(nomeGrupo: string) {
      emitir("update:nomeGrupo", nomeGrupo)
    },
  })

  const emitirUsuariosResponsaveis = computed({
    get() {
      return props.usuariosResponsaveis
    },
    set(usuariosResponsaveis: string[]) {
      emitir("update:usuariosResponsaveis", usuariosResponsaveis)
    },
  })

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const regras: ValidationArgs<{ nomeGrupo: any }> = {
    nomeGrupo: {
      obrigatorio: helpers.withMessage(t('campoObrigatorio'), required),
    },
  }

  const v$ = useVuelidate(
    regras,
    {
      nomeGrupo: emitirnomeGrupo,
      usuariosResponsaveis: emitirUsuariosResponsaveis,
    },
    { $scope: props.escopoValidacao }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MInput), {
      modelValue: _unref(v$).nomeGrupo.$model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).nomeGrupo.$model) = $event)),
      class: _normalizeClass(["ODadosGrupo__Nome", { 'p-invalid': _unref(v$).nomeGrupo.$invalid }]),
      "data-testid": "ODadosGrupo__Nome",
      label: _unref(t)('nomeDoGrupo'),
      "mensagem-de-erro": _unref(v$).nomeGrupo.$errors[0]?.$message,
      nome: "nomeGrupo",
      obrigatorio: "",
      "tipo-entrada": "text"
    }, null, 8, ["modelValue", "class", "label", "mensagem-de-erro"]),
    _createVNode(_unref(MMultiSelect), {
      modelValue: _unref(emitirUsuariosResponsaveis),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(emitirUsuariosResponsaveis) ? (emitirUsuariosResponsaveis).value = $event : null)),
      carregando: __props.estaCarregandoUsuariosResponsaveis,
      class: "ODadosGrupo__UsuariosResponsaveis",
      "data-testid": "ODadosGrupo__UsuariosResponsaveis",
      "exibicao-de-opcoes": "comma",
      "maximo-de-legendas-selecionadas": 3,
      "option-label": "nome",
      "option-value": "id",
      options: __props.usuariosResponsaveisOpcoes,
      placeholder: _unref(t)('usuariosResponsaveis'),
      width: "100px"
    }, null, 8, ["modelValue", "carregando", "options", "placeholder"])
  ]))
}
}

})